import React from "react";
import logoBlack from "../../assets/logo-black.svg";
import { DEFAULT_CAMPAIGN } from "../../context/CampaignContext";
import { LogoutButton } from "./LogoutButton";

export function EmptyState() {
  return (
    <div className="results results--confirmation">
      <div className="results__card results__card--confirmation">
        <img
          src={logoBlack}
          alt="De Carona com Toro"
          className="results__logo results__logo--numbers"
        />

        <h1 className="results__title results__title--confirmation">
          Você ainda não tem participações
        </h1>

        <p className="results__subtitle">
          Compre um curso participante e concorra
          <br />
          de carona com o Toro!
        </p>

        <div className="results__buttons">
          <a
            href={DEFAULT_CAMPAIGN.purchaseUrl}
            className="btn btn--yellow results__cta"
            target="_blank"
            rel="noopener noreferrer"
          >
            Quero participar
          </a>
          <LogoutButton extraClassName="results__logout" />
        </div>
      </div>
    </div>
  );
}
